import React, { useState } from 'react';
import { createCourseFromCourseElement, createCategoriesFromCourseElement,
  findElementinSubElementsByName } from '../utils';
import './GeneratorApp.css';

const convert = require('xml-js');
const columns = ['Delivery', 'Cost', 'Capabilities', 'Provider', 'Duration', 'Audience'];
const expandCollapseBtnStl = {marginLeft: "10px"}
const GeneratorApp = props => {
  const [companyIds, setCompanyIds] = useState('');
  const [categories, setCategories] = useState();
  const [courses, setCourses] = useState();
  const [generatedCode, setGeneratedCode] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [basicDisplayMode, setBasicDisplayMode] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([])
  const [selectedCourses, setSelectedCourses] = useState([])
  const [selectedColumns, setSelectedColumns] = useState([])
  const [showCategories, setShowCategories] = useState(false)
  const [showCourses, setShowCourses] = useState(false)
  const [copiedToClipboard, setCopiedToClipboard]= useState(false)
  const [fetchErrors, setFetchErrors]= useState(false)

  const fetchCompanies = () => {
    if (companyIds.length) {  
      let companies = companyIds.replace(/ /g, '').split(',').filter(c => !!c)
      const API_URL = "https://cosy.ox.ac.uk/accessplan/services/WebIntegration.asmx/GetCoursesPackageWithCourseDateText";
    
      let fetchPromises = companies.map(companyId => {
        return new Promise((resolve, reject) => {
          try {
            let dataAsJson = {};
            fetch(`${API_URL}?companyID=${companyId}&categoryIDs=&courseIds=&venueIds=`)
            .then(response => response.text())
            .then(str => {
              try {
                dataAsJson = JSON.parse(convert.xml2json(str))
              } catch (error) {
                console.log("error parsing XML", error);
                resolve({error: true})
              }
            })
            .then(() => {
              if (
                dataAsJson.elements && dataAsJson.elements.length &&
                dataAsJson.elements[0].elements !== undefined && dataAsJson.elements[0].elements.length &&
                dataAsJson.elements[0].elements[0].elements && dataAsJson.elements[0].elements[0].elements.length
              ) {
                const categoriesTable = createCategoriesFromCourseElement(findElementinSubElementsByName(dataAsJson.elements[0].elements, "Categories"));
    
                let newCourses = dataAsJson.elements[0].elements[0].elements.map(c => createCourseFromCourseElement(c, categoriesTable, companyId))
                resolve({courses: newCourses, categories: categoriesTable})
              } else {
                resolve({courses: [], categories: []})
              }
            });
          } catch (error) {
            console.log(error);
            resolve({courses: [], categories: []})
          }
        })
      })
      setIsFetching(true)
      Promise.all(fetchPromises)
      .then((promiseResult) => {
        if (promiseResult.map(r => r.error).filter(r => !!r).length) {
          setFetchErrors(true)
        } else {
          setFetchErrors(false)
        }
        setCourses(promiseResult.map(r => r.courses)
          .flat().filter(c => !!c).sort((a, b) => a.coursename.toLowerCase() < b.coursename.toLowerCase() ? -1 : 1))
        setCategories(promiseResult.map(r => r.categories)
          .flat().filter(c => !!c).sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1))
        setIsFetching(false)
      });
    }
  }

  const generateCode = () => {
    // the indentetion/new-lines here doesn't mke any sense, I am just trying to create a nicer string the user will copy to clipboard
    let txt = (`<div id="app"
      data-company-id="${companyIds.replace(/ /g, '').split(',').join(', ')}"
      data-columns-to-display="Course title, ${selectedColumns.join(', ')}"
      data-display-mode="${basicDisplayMode ? 'basic' : 'full'}"`)
    if (selectedCategories.length) {
      txt += `
      data-category-id="${selectedCategories.join(', ')}"`
    }
    if (selectedCourses.length) {
      txt += `
      data-course-id="${selectedCourses.join(', ')}"`
    }
    txt += `></div>
<script src="https://accessplanit-production-www.s3.eu-west-2.amazonaws.com/static/js/main.js"></script>
<link href="https://accessplanit-production-www.s3.eu-west-2.amazonaws.com/static/css/main.css" rel="stylesheet" />`

    setGeneratedCode(txt)
  }

  return (<>
    <h1>CoSy Course Signposting Embed Code Tool v3.0</h1>
    <label>
      Company Ids
      <input type="text" name="name" size="40" style={{marginLeft: "10px"}}
        value={companyIds} placeholder="OXFORDXU4U, OXFORDBODL"
        onChange={ev => setCompanyIds(ev.target.value)}/>
    </label>
    <br /><br />
    <label>Columns:</label><br />
    {
      columns.map(column =>
        <label key={column}>
        <input type="checkbox"
                  checked={selectedColumns.indexOf(column) > -1}
                  onChange={() => {
                    if (selectedColumns.indexOf(column) > -1) {
                      setSelectedColumns(cur => cur.filter(c => c !== column))
                    } else {
                      setSelectedColumns(cur => [...cur, column])
                    }
                  }} /> {column}<br />
        </label>
      )
    }
    <br /><br />
    <button disabled={companyIds === ''} onClick={fetchCompanies}>Get categories and courses</button>
    <br /><br />
    {isFetching
      ? <p>Loading...</p>
      : <>
        {categories?.length
          ? <div>
            Optionally, select one or more categories 
            {showCategories
              ? <button aria-label={"hide categories"} style={expandCollapseBtnStl} onClick={() => setShowCategories(false)}> - </button>
              : <button aria-label={"show categories"} style={expandCollapseBtnStl} onClick={() => setShowCategories(true)}> + </button>
            }
            {showCategories && categories.map(category => 
              <div key={category.categoryId}><label>
                <input type="checkbox"
                  checked={selectedCategories.indexOf(category.categoryId) > -1}
                  onChange={() => {
                    if (selectedCategories.indexOf(category.categoryId) > -1) {
                      setSelectedCategories(cur => cur.filter(c => c !== category.categoryId))
                    } else {
                      setSelectedCategories(cur => [...cur, category.categoryId])
                    }
                  }} />
                {category.name}
              </label></div>
            )}
            <br /><br />
          </div>
          : <div>No categories found <br /><br /></div>
        }
        {courses?.length
          ? <div>
            Optionally, select one or more courses
            {showCourses
              ? <button aria-label={"hide courses"} style={expandCollapseBtnStl} onClick={() => setShowCourses(false)}> - </button>
              : <button aria-label={"show courses"} style={expandCollapseBtnStl} onClick={() => setShowCourses(true)}> + </button>
            }
            {showCourses && courses.map(course => 
              <div key={course.courseid}><label>
                <input type="checkbox"
                  checked={selectedCourses.indexOf(course.courseid) > -1}
                  onChange={() => {
                    if (selectedCourses.indexOf(course.courseid) > -1) {
                      setSelectedCourses(cur => cur.filter(c => c !== course.courseid))
                    } else {
                      setSelectedCourses(cur => [...cur, course.courseid])
                    }
                  }} />
                {course.coursename}
              </label></div>
            )}
            <br /><br />
          </div>   
          : <div>No courses found <br /><br /></div>
        }
        {fetchErrors && <div>Failed to fetch categories and courses for some of the provided Company Ids<br /><br /></div>}
      </>
    }
    
    <button disabled={companyIds === ''} onClick={generateCode}>Generate embed-code</button>
    <br /><br />
    {generatedCode &&
      <label>
        Generated embed-code:
        <br />
        <textarea id="generated-code" name="generated-code" rows="7" cols="80" value={generatedCode} onChange={ev => setGeneratedCode(ev.target.value)}/>
        <br />
        <button onClick={() => {
          const textArea = document.getElementById("generated-code");
          textArea.focus();
          textArea.select();
          try {
            document.execCommand('copy');
            setCopiedToClipboard("Copied!")
            setTimeout(() => {
              setCopiedToClipboard(false)
            }, 2000);
          } catch (err) {
            setCopiedToClipboard("Failed to copy...")
            setTimeout(() => {
              setCopiedToClipboard(false)
            }, 2000);
            console.error('Unable to copy to clipboard', err);
          }
          }}>{copiedToClipboard || 'Copy to clipboard'}</button>
        
      </label>
    }
    <br /><br />
    <label>Basic Portal Mode<input type="checkbox" checked={basicDisplayMode} onChange={(ev) => setBasicDisplayMode(ev.target.checked)} />
    </label>
    <br /><br />
    <h2>Using the embed tool</h2>
    <p>To access the instructions to use the embed tool visit the <a href="https://skills.it.ox.ac.uk/course-signposting-tool">IT Services - Training Course Signposting Teams site</a>. If you don't have access, complete the Code Generator Request at <a href="https://skills.it.ox.ac.uk/course-signposting-tool">https://skills.web.ox.ac.uk/course-signposting-tool</a>. Follow the instructions carefully to complete the signposting process successfully. Contact the <a href="mailto:cosy-support@it.ox.ac.uk">cosy-support@it.ox.ac.uk</a> for assistance if needed.</p>
  </>)
}

export default GeneratorApp;
